import {Units} from "@/services/units";

const loadAll = (context) => {
  (new Units(true)).fetch().then(
    res => context.commit('SET_UNITS', res.data)
  ).catch(
    e => console.error(e)
  )
}

const load = (context, unitId) => {
  (new Units(true)).fetch(unitId).then(
    res => context.commit('SET_UNIT', res.data)
  ).catch(
    e => console.error(e)
  )
}

const save = (context, params) => {
  (new Units(true)).save(params).then(
    res => params.id ? context.commit('UPDATE', params) : context.commit('PUSH', res.data)
  ).catch(
    e => console.error(e)
  )
}

const remove = (context, unitId) => {
  (new Units(true)).destroy(unitId).then(
    () => context.commit('REMOVE', unitId)
  ).catch(
    e => console.error(e)
  )
}

export default {
  save,
  load,
  remove,
  loadAll
}
